import { SearchLoop, Filter } from 'assets/icons';
import StyledInput from 'components/styledInput/StyledInput';
import ThreeStateCheckbox from 'components/threeStateCheckbox/threeStateCheckbox';
import Pagination from 'components/pagination/pagination';
import Fuse from 'fuse.js';
import UseContext from 'hooks/useContext';
import useImportedTimeSheet from 'hooks/useImportedTimeSheet';
import MediaQuery from 'react-responsive';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import removeAccents from 'remove-accents';
import ApiDatabase from 'server';
import PageForm from '../../components/pageForm/PageForm';
import SubNavbar from '../../components/SubNavbar/SubNavbar';
import TimeSheetSubNav from '../../components/subnav/timeSheet.subNav';
import Button from '../../components/button';
import BottomSheet from '../../components/bottomSheet/BottomSheet';
import { formatDateToYMD } from '../../helper/helper';

const TimeSheet = () => {
  const location = useLocation();
  const {
    companyData,
    refreshTime,
    currentPageTimeSheetChecked,
    setCurrentPageTimeSheetChecked,
    timeSheetSearchTimeSheetChecked,
    setTimeSheetSearchTimeSheetChecked,
    timeSheetSearchTypeTimeSheetChecked,
    setTimeSheetSearchTypeTimeSheetChecked,
    dateRangeTimeSheetChecked,
    setDateRangeTimeSheetChecked,
    currentPageTimeSheetLitigation,
    setCurrentPageTimeSheetLitigation,
    timeSheetSearchTimeSheetLitigation,
    setTimeSheetSearchTimeSheetLitigation,
    timeSheetSearchTypeTimeSheetLitigation,
    setTimeSheetSearchTypeTimeSheetLitigation,
    dateRangeTimeSheetLitigation,
    setDateRangeTimeSheetLitigation,
    currentPageTimeSheetToBeChecked,
    setCurrentPageTimeSheetToBeChecked,
    timeSheetSearchTimeSheetToBeChecked,
    setTimeSheetSearchTimeSheetToBeChecked,
    timeSheetSearchTypeTimeSheetToBeChecked,
    setTimeSheetSearchTypeTimeSheetToBeChecked,
    dateRangeTimeSheetToBeChecked,
    setDateRangeTimeSheetToBeChecked,
  } = UseContext();

  const [arrayTimeSheets, setArrayTimeSheets] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitElement, setLimitElement] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [countPerPage, setCountPerPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const [timeSheetSearch, setTimeSheetSearch] = useState('');
  const [timeSheetSearchType, setTimeSheetSearchType] = useState('');
  const [dateRange, setDateRange] = useState([null, null]);
  const [isFirstSearchDone, setIsFirstSearchDone] = useState(false);
  const [currentPageBackup, setCurrentPageBackup] = useState(1);
  const [status, setStatus] = useState('1');
  const [timeSheetsToDisplay, setTimeSheetsToDisplay] = useState([]);

  const [startDate, endDate] = dateRange;

  const [isTimeSheetImported, setIsTimeSheetImported] = useState(false);

  const { timeSheetVerified } = useImportedTimeSheet();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  
  // États temporaires pour le BottomSheet (appliqués uniquement au clic sur Appliquer)
  const [tempSearch, setTempSearch] = useState('');
  const [tempSearchType, setTempSearchType] = useState('');
  const [tempDateRange, setTempDateRange] = useState([null, null]);
  const [tempIsImported, setTempIsImported] = useState(false);
  const [tempStartDate, tempEndDate] = tempDateRange;
  
  // Ouvrir le BottomSheet et initialiser les valeurs temporaires
  const openFilterSheet = () => {
    setTempSearch(timeSheetSearch);
    setTempSearchType(timeSheetSearchType);
    setTempDateRange(dateRange);
    setTempIsImported(isTimeSheetImported);
    setIsFilterOpen(true);
  };
  
  // Appliquer les filtres
  const applyFilters = () => {
    setTimeSheetSearch(tempSearch);
    setTimeSheetSearchType(tempSearchType);
    setDateRange(tempDateRange);
    setIsTimeSheetImported(tempIsImported);
    setIsFilterOpen(false);
  };

  const token = localStorage.getItem('xsrfToken');

  const manageTimeSheetSearch = () => {
    setIsWaiting(true);
    const timeSheetSearchOptions = {
      type: null,
      startDate: startDate ? formatDateToYMD(startDate) : null,
      endDate: endDate ? formatDateToYMD(endDate) : null,
      isTimeSheetImported,
    };

    ApiDatabase.getTimeSheets(
      {
        token,
        status,
        searchOptions: timeSheetSearchOptions,
      },
      (data) => {
        setArrayTimeSheets(data.timeSheets);
        setCountPerPage(limitElement);
        setIsWaiting(false);
        setIsFirstSearchDone(true);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.log(err);
        }
      }
    );
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [
    timeSheetSearch,
    timeSheetSearchType,
    startDate,
    endDate,
    status,
    isTimeSheetImported,
  ]);

  useEffect(() => {
    let filteredTimeSheets = arrayTimeSheets;
    if (timeSheetSearch.length > 0) {
      const searchTerm = removeAccents(timeSheetSearch.toLowerCase());

      if (timeSheetSearchType) {
        filteredTimeSheets = arrayTimeSheets.filter((item) => {
          const searchFields = {
            id_time_sheet: item.id_time_sheet?.toString(),
            id_mission: item.id_mission_reel?.toString(),
            id_contract_bestt: item.id_bestt_contract?.toString(),
            id_bestt_temp_worker: item.id_bestt_temp_worker?.toString(),
            name_company: removeAccents(
              (item.reason_social + ' ' + item.name_commercial)?.toLowerCase()
            ),
            temp_worker_name: removeAccents(
              (item.firstname + ' ' + item.lastname)?.toLowerCase()
            ),
          };

          const fieldValue = searchFields[timeSheetSearchType] || '';
          return fieldValue.includes(searchTerm);
        });
      } else {
        const searchTerms = searchTerm.split(' ');
        const options = {
          keys: [
            'id_time_sheet',
            'id_user',
            'title',
            'id_mission_reel',
            'lastname',
            'firstname',
            'id_bestt_temp_worker',
            'reason_social',
            'name_commercial',
            'id_bestt_company',
            'id_bestt_contract',
            'id_mission',
          ],
          includeScore: true,
          threshold: 0.3,
          distance: 100,
          shouldSort: true,
          getFn: (obj, path) => {
            const value = Fuse.config.getFn(obj, path);
            if (value == null) {
              return '';
            }
            return removeAccents(value.toString().toLowerCase());
          },
        };

        const fuse = new Fuse(arrayTimeSheets, options);
        const combinedResults = {};

        searchTerms.forEach((term) => {
          const result = fuse.search(term);
          result.forEach(({ item, score }) => {
            const indexSearch = item._id + item.id_mission;
            if (combinedResults[indexSearch]) {
              combinedResults[indexSearch].score -= score;
            } else {
              combinedResults[indexSearch] = { item, score };
            }
          });
        });

        const sortedResults = Object.values(combinedResults).sort(
          (a, b) => a.score - b.score
        );
        filteredTimeSheets = sortedResults.map((result) => result.item);
      }
    }

    setTimeSheetsToDisplay(
      filteredTimeSheets.slice(
        (currentPage - 1) * countPerPage,
        currentPage * countPerPage
      )
    );
    setCountTotal(filteredTimeSheets.length);
    setTotalPages(Math.ceil(filteredTimeSheets.length / countPerPage));
  }, [
    timeSheetSearch,
    timeSheetSearchType,
    arrayTimeSheets,
    currentPage,
    countPerPage,
  ]);

  useEffect(() => {
    manageTimeSheetSearch();
  }, [
    companyData,
    refreshTime,
    startDate,
    endDate,
    status,
    isTimeSheetImported,
  ]);

  // Redirect to toBeCompleted if on base /timeSheet route
  if (location.pathname === '/timeSheet') {
    return <Navigate to="/timeSheet/toBeCompleted" replace />;
  }

  return (
    <PageForm>
      <>
        {!location.pathname.startsWith('/timeSheet/ficheHour/') && (
          <SubNavbar>
            <div className="flex justify-between items-center w-full gap-3">
              {/* Desktop: Left controls - horizontally scrollable */}
              <MediaQuery minWidth={768}>
                <div className="flex-1 overflow-x-auto overflow-y-hidden" style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                  <style>{`
                    .flex-1.overflow-x-auto::-webkit-scrollbar {
                      display: none;
                    }
                  `}</style>
                  <div className="flex gap-3 items-center min-w-max">
                  <div className="text-sm relative z-30">
                    <DatePicker
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable={true}
                      placeholderText="Sélectionner une période"
                      className="w-full min-w-[180px] h-10 pl-3 pr-8 ft-b border rounded-md text-left text-sm focus:border-yellow-500 focus:outline-none"
                      locale="fr-FR"
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  <div className={'flex gap-2 items-center'}>
                    <div className={'flex-1 max-w-[280px] text-sm searchbar-time-sheet'}>
                      <StyledInput
                        type={'text'}
                        placeholder={'Rechercher'}
                        imgFront={<SearchLoop wh={16} color={'#6B7280'} />}
                        value={timeSheetSearch}
                        onChange={(e) => setTimeSheetSearch(e.target.value)}
                      />
                    </div>
                    <div className={'max-w-[120px]'}>
                      <select
                        className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-md text-sm options-time-sheet focus:border-yellow-500 focus:outline-none"
                        onChange={(e) => setTimeSheetSearchType(e.target.value)}
                        value={timeSheetSearchType}
                      >
                        <option value="">Tous</option>
                        <option value="id_time_sheet">ID Relevé Heure</option>
                        <option value="id_mission">ID Mission</option>
                        <option value="id_contract_bestt">ID BeSTT Contrat</option>
                        <option value="id_bestt_temp_worker">
                          ID BeSTT Intérimaire
                        </option>
                        <option value="name_company">Nom Entreprise</option>
                        <option value="temp_worker_name">Nom Intérimaire</option>
                      </select>
                    </div>
                    {timeSheetVerified && (
                      <div className="border rounded py-2 px-4 text-sm imported-time-sheet">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <ThreeStateCheckbox
                            checked={isTimeSheetImported}
                            onChange={setIsTimeSheetImported}
                          />
                          <div>Importé</div>
                        </label>
                      </div>
                    )}
                  </div>
                  </div>
                </div>
              </MediaQuery>
              {/* Mobile: Tout scrollable (bouton Filtrer + tabs) */}
              <MediaQuery maxWidth={767}>
                <div className="flex items-center gap-3 min-w-max">
                  <Button
                    color={'SECONDARY'}
                    size={'SM'}
                    onClick={openFilterSheet}
                  >
                    <Filter wh={16} color="#374151" />
                    <span>Filtrer</span>
                  </Button>
                  <div className="h-8 w-px bg-gray-200"></div>
                  <TimeSheetSubNav />
                </div>
              </MediaQuery>
              {/* Desktop: Tabs - always visible, no scroll */}
              <MediaQuery minWidth={768}>
                <div className="flex-shrink-0 flex items-center gap-3">
                  <div className="h-8 w-px bg-gray-200"></div>
                  <TimeSheetSubNav />
                </div>
              </MediaQuery>
            </div>
          </SubNavbar>
        )}
        <div className="flex flex-col w-full h-full overflow-hidden">
          <div className="flex-1 overflow-y-auto">
        <Outlet
          context={{
            timeSheetsToDisplay,
            setTimeSheetsToDisplay,
            timeSheetSearch,
            setTimeSheetSearch,
            timeSheetSearchType,
            setTimeSheetSearchType,
            currentPage,
            setCurrentPage,
            totalPages,
            setTotalPages,
            countPerPage,
            setCountPerPage,
            countTotal,
            setCountTotal,
            isWaiting,
            setIsWaiting,
            dateRange,
            setDateRange,
            startDate,
            endDate,
            status,
            setStatus,
          }}
        />
      </div>
          {!location.pathname.startsWith('/timeSheet/ficheHour/') && currentPage && totalPages > 1 && setCurrentPage ? (
            <div className="flex-shrink-0 border-t border-gray-100 bg-white px-8 py-4">
              <Pagination
                currentPage={currentPage}
                countPerPage={countPerPage}
                countTotal={countTotal}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
              />
            </div>
          ) : null}
        </div>

        {/* Bottom Sheet Filtre pour mobile */}
        <BottomSheet
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          title="Filtrer"
        >
          <div className="flex flex-col gap-4">
            {/* Période */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Période
              </label>
              <DatePicker
                selectsRange={true}
                startDate={tempStartDate}
                endDate={tempEndDate}
                onChange={(update) => {
                  setTempDateRange(update);
                }}
                isClearable={true}
                placeholderText="Sélectionner une période"
                className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-left text-sm focus:border-yellow-500 focus:outline-none"
                locale="fr-FR"
                dateFormat="dd/MM/yyyy"
              />
            </div>

            {/* Recherche */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Rechercher
              </label>
              <StyledInput
                type={'text'}
                placeholder={'Rechercher...'}
                imgFront={<SearchLoop wh={16} color={'#6B7280'} />}
                value={tempSearch}
                onChange={(e) => setTempSearch(e.target.value)}
              />
            </div>

            {/* Type de recherche */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Rechercher par
              </label>
              <select
                className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg text-sm focus:border-yellow-500 focus:outline-none"
                onChange={(e) => setTempSearchType(e.target.value)}
                value={tempSearchType}
              >
                <option value="">Tous</option>
                <option value="id_time_sheet">ID Relevé Heure</option>
                <option value="id_mission">ID Mission</option>
                <option value="id_contract_bestt">ID BeSTT Contrat</option>
                <option value="id_bestt_temp_worker">ID BeSTT Intérimaire</option>
                <option value="name_company">Nom Entreprise</option>
                <option value="temp_worker_name">Nom Intérimaire</option>
              </select>
            </div>

            {/* Checkbox Importé */}
            {timeSheetVerified && (
              <div className="border rounded-lg py-3 px-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <ThreeStateCheckbox
                    checked={tempIsImported}
                    onChange={setTempIsImported}
                  />
                  <span className="text-sm">Relevés importés</span>
                </label>
              </div>
            )}

            {/* Bouton Appliquer */}
            <div className="mt-2">
              <Button
                color={'PRIMARY'}
                size={'FULL'}
                onClick={applyFilters}
              >
                Appliquer
              </Button>
            </div>
          </div>
        </BottomSheet>
      </>
    </PageForm>
  );
};

export default TimeSheet;
